import { logCopilotChatSidePaneTelemetryEvent } from 'owa-copilot-telemetry/lib/copilotChatSidePaneTelemetryLogger';
import isPopout from 'owa-popout-v2/lib/utils/isPopout';
import isDeepLink from 'owa-url/lib/isDeepLink';
import type { MailboxInfo } from 'owa-client-types';
import { getCopilotChatDrawerWidthBucket } from './copilotChatDrawerLocalStorage';

let hasLoggedThisSession = false;

/**
 * Logs the user's starting Copilot Chat Drawer width bucket once per session.
 * Intended to be called when the drawer first renders so we capture the
 * distribution of users on the default width vs. customized widths vs.
 * customized-to-minimum (380px).
 *
 * Skips popout / deep-link windows since those never read or write the
 * saved width preference.
 */
export function logCopilotChatDrawerStartingWidth(
    targetWindow: Window,
    mailboxInfo: MailboxInfo
): void {
    if (hasLoggedThisSession) {
        return;
    }
    if (isPopout(targetWindow) || isDeepLink()) {
        return;
    }
    hasLoggedThisSession = true;

    logCopilotChatSidePaneTelemetryEvent(
        'CopilotSidePane_StartingWidth',
        {
            startingWidthBucket: getCopilotChatDrawerWidthBucket(),
        },
        mailboxInfo
    );
}
